// extracted by mini-css-extract-plugin
module.exports = {"color-subtle-grey":"#f5f4f2","colorSubtleGrey":"#f5f4f2","color-text-grey":"#707070","colorTextGrey":"#707070","button":"B3BXv"};